var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17 9.097c0-.9.52-1.798 1.53-2.506 1.007-.707 2.443-1.17 4.069-1.17 1.625 0 3.061.463 4.069 1.17 1.01.708 1.528 1.607 1.528 2.506 0 .518-.168 1.024-.497 1.497a.835.835 0 101.372.954c.5-.72.796-1.553.796-2.451 0-1.593-.921-2.95-2.24-3.874-1.32-.927-3.101-1.473-5.028-1.473-1.928 0-3.708.546-5.029 1.473-1.318.924-2.24 2.281-2.24 3.874s.922 2.95 2.24 3.874c1.32.926 3.101 1.473 5.029 1.473.012 0 .023.01.023.023v1.1c0 .14.151.227.272.157l3.465-2a.182.182 0 000-.315l-3.465-2a.182.182 0 00-.272.157v1.184c0 .013-.01.023-.023.023-1.626 0-3.062-.463-4.07-1.17-1.01-.708-1.528-1.607-1.528-2.506z",
    fill: "currentColor"
  })));
}

export default SvgAppLogo;